import React, { useState, useEffect } from 'react';
import * as moment from 'moment';
import {
  DesktopDatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FormControl, TextField } from '@mui/material';
import '../../utils/date';

export default function DateMonthPicker({
  className,
  onChange,
  label,
  required,
  error,
  format,
  view,
  value,
  useToFilter,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const onChangeHandler = (date) => {
    if (isNaN(date)) return; // When user is typing, we get some invalid dates
    if (isOpen) return; // When user is picking a date from interface should not use this handler

    if (date) onChange(date, formatDate(date));
    else onChange(null, null);
  };

  const formatDate = (date) => {
    let newDate = moment(date).format('YYYY-MM');
    return newDate;
  };
  const onYearChangeHandler = (date) => {
    setIsOpen(false);
    onChange(date, formatDate(date));
  };

  useEffect(() => {
    // Only initialize once
    if (initialized) return;
    
    // If useToFilter is true, set the value to empty
    if (useToFilter) {
      onChange(null, '');
    } else if (!value) {
      // If there is no value and it's not for filtering, set the default value
      let today = new Date();
      onChange(today, formatDate(today));
    }
    
    setInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      fullWidth
      variant="outlined"
      margin={useToFilter ? 'none' : 'normal'}
      className={className}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          label={label}
          inputFormat={format}
          views={view}
          openTo={view && view.length ? (view.includes('month') ? 'month' : view[0]) : undefined}
          value={value}
          onChange={onChangeHandler}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              required={required}
              error={error}
            />
          )}
          onYearChange={onYearChangeHandler}
          onOpen={() => {
            setIsOpen(true);
          }}
          onClose={() => {
            setIsOpen(false);
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
}
